import { render, staticRenderFns } from "./terminos.vue?vue&type=template&id=1de1e266&"
import script from "./terminos.vue?vue&type=script&lang=js&"
export * from "./terminos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports